import React from 'react';
import About from './about';
import Skills from './skills';
import Education from './education';
import Footer from './footer';
import '../styles/style.css';
import { credibility, experience, profile } from '../data/portfolio';

function Home() {
    return (
        <div className="site-shell">
            <header className="site-header" id="hero-section">
                <nav className="site-nav" aria-label="Main navigation">
                    <a className="brand-mark" href="#hero-section" aria-label="Daryle Urrea home">DU</a>
                    <div className="nav-links">
                        <a href="#aboutme-section">About</a>
                        <a href="#experience-section">Experience</a>
                        <a href="#skills-section">Skills</a>
                        <a href="#education-section">Education</a>
                    </div>
                </nav>

                <section className="hero-section section-wrap">
                    <div className="hero-copy">
                        <p className="eyebrow">{profile.location}</p>
                        <h1>{profile.headline}</h1>
                        <p className="hero-summary">{profile.summary}</p>
                    </div>

                    <aside className="hero-card" aria-label="Profile summary">
                        <div className="portrait-frame">
                            <img src={`${process.env.PUBLIC_URL}/images/darylelinkedin2021_v3.png`} alt="Daryle Urrea profile portrait" />
                        </div>
                        <div className="profile-plate">
                            <div>
                                <p className="card-kicker">{profile.role}</p>
                                <h2>{profile.name}</h2>
                            </div>
                            <div className="profile-links" aria-label="Profile links">
                                <a className="linkedin-icon" href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn profile">in</a>
                            </div>
                        </div>
                    </aside>
                </section>

                <section className="credibility-grid section-wrap" aria-label="Credibility snapshot">
                    {credibility.map((item) => (
                        <div className="metric-card" key={item.label}>
                            <span>{item.value}</span>
                            <p>{item.label}</p>
                        </div>
                    ))}
                </section>
            </header>

            <main>
                <About />
                <section className="section-wrap proof-section" id="experience-section">
                    <div className="section-heading">
                        <p className="eyebrow">Experience</p>
                        <h2>Product engineering, EdTech systems, and technical operations.</h2>
                    </div>
                    <div className="experience-list">
                        {experience.map((item) => (
                            <article className="experience-card" key={`${item.role}-${item.period}`}>
                                <div>
                                    <p className="experience-period">{item.period}</p>
                                    <h3>{item.role}</h3>
                                    <p className="experience-company">{item.company}</p>
                                </div>
                                <p>{item.focus}</p>
                            </article>
                        ))}
                    </div>
                </section>
                <Skills />
                <Education />
            </main>

            <Footer />
        </div>
    );
}

export default Home;
